import './navigation.js';
import './skip-link-focus-fix.js'
(( $ ) => {


	$(document).ready( () => {

		// var swiper = new Swiper('.swiper-container', {
		//
    //   loop: false,
    // });

		// product lift groups functionality
		$('.group-title').first().addClass('active');
		$('.sub-menu-item').first().addClass('active');

		$('.lift-group').first().addClass('active');
		// show first batch of lifts
		var first = $('.product-lifts').first();
		$(first).addClass('active');
		gsap.set(first,{ x: 0, display: 'flex'});

			// lift-groups
		$('.group-title').click(function () {

			$('.group-title').removeClass('active');
			$(this).addClass('active');

			var active = $(this).attr("rel");

			$('.lift-group').not("#"+active).removeClass("active");
			$("#"+active).addClass("active");
			var firstGroup = $("#"+active).find('.product-lifts').first();
			gsap.fromTo(firstGroup,{ x: -2000, display: 'flex'}, {x: 0, duration: 0.5, ease: "power2.inOut"});
			$("#"+active).find('.product-lifts').first().addClass("active");
				$("#"+active).find('.sub-menu-item').first().addClass("active");

		});

			// sub-group-lifts
			$('.sub-menu-item').click(function () {

				$('.sub-menu-item').removeClass('active');
				$(this).addClass('active');

				var active = $(this).attr("rel");
				var activeGroup = $("#"+active);
				var previous = $('.product-lifts.active');
				var others =	$('.product-lifts').not(activeGroup);

				var tl = new TimelineMax();
				tl.fromTo(previous,{x: 0}, { x: 2000, duration: 0.4, ease: "power2.inOut" });
				tl.set(previous, {display: 'none'});
				tl.fromTo(activeGroup,{ x: -2000, display: 'flex'}, {x: 0, duration: 0.5, ease: "power2.inOut", onComplete: editClass});

				function editClass() {
					$(activeGroup).addClass("active");
					$(previous).removeClass("active");
				}

			});

			// $('#menu-toggle').click(function () {
			// 	$('#top-menu').slideToggle();
			// });


	});


	/* optional triggers

	$(window).load(() => {

	});

	$(window).resize(() => {

	});

	*/


} )( jQuery );



// WEBPACK FOOTER //
// ./assets/js/app.js